/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationCorporationIdMiningObserversObserverId200Ok
 */
export interface GetCorporationCorporationIdMiningObserversObserverId200Ok {
    /**
     * The character that did the mining
     * 
     * @type {number}
     * @memberof GetCorporationCorporationIdMiningObserversObserverId200Ok
     */
    characterId: number;
    /**
     * last_updated string
     * @type {Date}
     * @memberof GetCorporationCorporationIdMiningObserversObserverId200Ok
     */
    lastUpdated: Date;
    /**
     * quantity integer
     * @type {number}
     * @memberof GetCorporationCorporationIdMiningObserversObserverId200Ok
     */
    quantity: number;
    /**
     * The corporation id of the character at the time data was recorded.
     * 
     * @type {number}
     * @memberof GetCorporationCorporationIdMiningObserversObserverId200Ok
     */
    recordedCorporationId: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetCorporationCorporationIdMiningObserversObserverId200Ok
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetCorporationCorporationIdMiningObserversObserverId200Ok interface.
 */
export function instanceOfGetCorporationCorporationIdMiningObserversObserverId200Ok(value: object): value is GetCorporationCorporationIdMiningObserversObserverId200Ok {
    if (!('characterId' in value) || value['characterId'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('recordedCorporationId' in value) || value['recordedCorporationId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetCorporationCorporationIdMiningObserversObserverId200OkFromJSON(json: any): GetCorporationCorporationIdMiningObserversObserverId200Ok {
    return GetCorporationCorporationIdMiningObserversObserverId200OkFromJSONTyped(json, false);
}

export function GetCorporationCorporationIdMiningObserversObserverId200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationCorporationIdMiningObserversObserverId200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'characterId': json['character_id'],
        'lastUpdated': (new Date(json['last_updated'])),
        'quantity': json['quantity'],
        'recordedCorporationId': json['recorded_corporation_id'],
        'typeId': json['type_id'],
    };
}

export function GetCorporationCorporationIdMiningObserversObserverId200OkToJSON(json: any): GetCorporationCorporationIdMiningObserversObserverId200Ok {
    return GetCorporationCorporationIdMiningObserversObserverId200OkToJSONTyped(json, false);
}

export function GetCorporationCorporationIdMiningObserversObserverId200OkToJSONTyped(value?: GetCorporationCorporationIdMiningObserversObserverId200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'character_id': value['characterId'],
        'last_updated': ((value['lastUpdated']).toISOString().substring(0,10)),
        'quantity': value['quantity'],
        'recorded_corporation_id': value['recordedCorporationId'],
        'type_id': value['typeId'],
    };
}

